import { Box } from '@mui/material';
import React, { ReactNode } from 'react';

export interface PageHeaderFiltersProps {
  children: ReactNode;
}

const PageHeaderFilters: React.FC<PageHeaderFiltersProps> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1,
      }}
    >
      {children}
    </Box>
  );
};

export default PageHeaderFilters;
